module.exports = __webpack_public_path__ + "static/Hemlibra_logo_white_EN-218cc1f0232ea1fff3e89f036cdd27f3.png";